import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownGroup} from '../../rules/ruleEditor/dropdowns/multipleGroupsDropdownHelpers';
import {RuleAddCard} from '../../rules/ruleEditor/ruleAddCard';
import {RuleConditionDefinition} from '../../rules/ruleParameterModel';
import {ConditionPicker} from './conditionPicker';

/*
 * Types.
 */

export enum ConditionsAddBlockTypesEnum {
  AND = 'and',
  OR = 'or',
}

interface ConditionAddBlockProps {
  type: ConditionsAddBlockTypesEnum;
  label?: string;
  shouldShowAdvanced: boolean;

  conditionGroups: ReadonlyArray<DropdownGroup<RuleConditionDefinition>>;
  onAddCondition: HandlerOf<RuleConditionDefinition>;
}

/*
 * Component.
 */

export const ConditionAddBlock: FC<ConditionAddBlockProps> = (props) => {
  const {type, label, shouldShowAdvanced, conditionGroups, onAddCondition} = props;

  const renderLabel = () => {
    if (label) {
      return label;
    }

    if (shouldShowAdvanced) {
      return <Trans id="condition">{getBlockTypeTranslation(type)} condition</Trans>;
    }

    return <Trans id="condition-capitalized">Condition</Trans>;
  };

  return (
    <ConditionPicker groups={conditionGroups} onAddCondition={onAddCondition}>
      <RuleAddCard label={renderLabel()} />
    </ConditionPicker>
  );
};

/*
 * Helpers.
 */

function getBlockTypeTranslation(type: ConditionsAddBlockTypesEnum) {
  switch (type) {
    case ConditionsAddBlockTypesEnum.AND:
      return <Trans id="condition-and-uppercase">AND</Trans>;

    case ConditionsAddBlockTypesEnum.OR:
      return <Trans id="condition-or-uppercase">OR</Trans>;

    default:
      return type;
  }
}
